<main class="offset-lg-3 col-lg-6 vragenlijst" id="advieswijzer-content">
  <h1 role="heading" aria-describedby="advieswijzer-lead">{{resources.subsiteTitle}} {{resources.websiteTitle}}
  </h1>
  <p id="advieswijzer-lead" class="lead">{{resources.leadText}}</p>
  <div class="form-header mb-2 mb-md-0">
    <h2>{{resources.questionHistoryHeader}}</h2>
    <div class="form-action">
      <span class="meta">{{resources.requiredFieldsText}}</span>
    </div>
  </div>
  <div>
    <app-question-history></app-question-history>
    @if (!showSuggestion && questions) {
      <app-question-list id="question-list" [questions]="questions">
      </app-question-list>
    }
    <div aria-live="polite">
      @if (showSuggestion) {
        <app-suggestion id="suggestion" [suggestion]="suggestion"></app-suggestion>
      }
      @if (showMoreInfo) {
        <div class="mt-3">
          <ngf-panel [title]="resources.moreInfoBlockTitle" id="more-info-panel">
            <div id="niet-gevonden-content" class="panel-body" [innerHtml]="resources.moreInfoText"></div>
          </ngf-panel>
        </div>
      }
    </div>
  </div>
</main>